import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container__icon" }
const _hoisted_2 = {
  key: 0,
  class: "container__name"
}
const _hoisted_3 = { class: "bs-sidebar-category__links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-sidebar-category", { 'category--opened': _ctx.isOpened, 'category--active': _ctx.isActive }]),
    ref: "container"
  }, [
    _createElementVNode("div", {
      class: "bs-sidebar-category__container",
      ref: "reference",
      onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpenTooltip && _ctx.onOpenTooltip(...args))),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpened = !_ctx.isOpened))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      (_ctx.opened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ], 544),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "links")
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "m-tooltip" }, {
        default: _withCtx(() => [
          (_ctx.isVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "bs-m-tooltip tooltip--base",
                ref: "tooltip",
                style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` })
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 2))
}